import React from 'react';

import Box from '@mui/material/Box';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';




export default function VECSSPropertyAdder(props) {

    // const cssProperties = props.componentsConfig.cssPropertiesList;
    const [searchQuery, setSearchQuery] = React.useState("");
    const [openDialog, setOpenDialog] = React.useState(false);
    const animateField = props.animate;

    const cssProperties = props.componentsConfig?.cssProperties;
    if (!cssProperties) {
        console.log("No CSS properties found!");
        console.log(props.componentsConfig);
        return null;
    }
    const cssPropertyNames = Object.keys(cssProperties).sort();

    return (
        <>
            <AddIcon key="addCSSIcon" fontSize="small" className="cursor-pointer" onClick={() => setOpenDialog(true)} />

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth={true} maxWidth="xs">
                <DialogTitle>
                    <span className="font-bold">Choose a property to add</span>
                </DialogTitle>
                <Box className="px-8 py-5 border-t">
                    <TextField autoComplete="off" variant="outlined" size="small" className="w-full" placeholder="Search" value={searchQuery} onChange={(event) => setSearchQuery(event.target.value)} />
                </Box>
                <Box className="p-0 border-t border-b h-80 overflow-y-auto">
                    {
                        (searchQuery.length) ? (
                            cssPropertyNames.filter((propertyName) => {
                                return propertyName.toLowerCase().includes(searchQuery.toLowerCase());
                            }).map((propertyName) => {
                                return printPropertyItem(propertyName);
                            })
                        )
                        : cssPropertyNames.map((propertyName) => {
                            return printPropertyItem(propertyName);
                        })
                    }
                </Box>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );

    function addCSSPropertyToForm(property) {
        props.onPropertyAdd(props.groupId, property, animateField);
        setOpenDialog(false);
    }

    function printPropertyItem(propertyName) {
        const property = cssProperties[propertyName];
        return (
            <Box
                className="px-8 py-5 hover:bg-yellow-100 cursor-pointer"
                key={propertyName}
                onClick={() => addCSSPropertyToForm(propertyName)}>
                <Box className="font-bold">{propertyName}</Box>
                <Box className="text-sm text-gray-500">{property.description ?? ""}</Box>
                {
                    (property.enum) ? (
                        <Box className="text-xs text-gray-500">Possible values: {property.enum.join(" | ")}</Box>
                    ) : null
                }
            </Box>
        );
    }
}